import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orpc } from "@/frontend/orpc-client";

export function useAcceptInvitationMutation() {
  const queryClient = useQueryClient();
  return useMutation(
    orpc.org.acceptInvitation.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.admin.listInvitations.key() });
      },
    })
  );
}

export function useConfirmInvitationIdentityMutation() {
  return useMutation(orpc.org.confirmInvitationIdentity.mutationOptions());
}

export function usePrepareInviteSignupMutation() {
  return useMutation(orpc.org.prepareInviteSignup.mutationOptions());
}

export function useRecordInviteActivityMutation() {
  return useMutation(orpc.org.recordInviteActivity.mutationOptions());
}

export function useSetActiveOrgMutation() {
  return useMutation(orpc.org.setActiveOrganization.mutationOptions());
}
